import { TwitchUser } from "../models/TwitchUser"
import { CanLoad } from "./CanLoad"
import { ServerCall } from "./ServerCall"

export abstract class UserReader<P = unknown, S = unknown> extends CanLoad<P, S>{
    abstract afterRead: (user: TwitchUser) => void
    abstract getUsername: () => string

    componentDidMount = () => {
        const user = this.context.getUser(this.getUsername())

        if(user)
            this.afterRead(user)
        else{
            this.toggleLoading()

            ServerCall.get<TwitchUser>("/gud/" + this.getUsername()).then(res => {
                this.afterRead(res)
                this.context.addUser(res)
            }).catch(() => {}).finally(this.toggleLoading)
        }
    }
}